export const loginOtpCodes = {
    en: {
        aotp403: 'Sign-in can no longer continue - please start again',
        aotp404: 'This sign-in attempt has expired - please start again',
        aotp409: 'An app user was already chosen for this sign-in',
        aotp410: 'The code has expired - request a new one',
        aotp422: 'Invalid code or user',
        aotp425: 'Please wait a few seconds before requesting a new code',
        aotp429: 'Too many codes requested - please start again',
        aotp503: 'Codes cannot be delivered right now - try again later',
    },
    pt: {
        aotp403: 'Não é possível continuar o acesso - comece novamente',
        aotp404: 'Esta tentativa de acesso expirou - comece novamente',
        aotp409: 'Um usuário do aplicativo já foi escolhido para este acesso',
        aotp410: 'O código expirou - solicite um novo',
        aotp422: 'Código ou usuário inválido',
        aotp425: 'Aguarde alguns segundos antes de solicitar um novo código',
        aotp429: 'Muitos códigos solicitados - comece novamente',
        aotp503: 'Não é possível enviar códigos agora - tente mais tarde',
    },
    es: {
        aotp403: 'No es posible continuar el inicio de sesión - vuelva a empezar',
        aotp404: 'Este intento de inicio de sesión ha caducado - vuelva a empezar',
        aotp409: 'Ya se eligió un usuario de la aplicación para este inicio de sesión',
        aotp410: 'El código ha caducado - solicite uno nuevo',
        aotp422: 'Código o usuario no válido',
        aotp425: 'Espere unos segundos antes de solicitar un código nuevo',
        aotp429: 'Se solicitaron demasiados códigos - vuelva a empezar',
        aotp503: 'No se pueden enviar códigos en este momento - inténtelo más tarde',
    },
    fr: {
        aotp403: 'La connexion ne peut pas continuer - veuillez recommencer',
        aotp404: 'Cette tentative de connexion a expiré - veuillez recommencer',
        aotp409: 'Un utilisateur de l\'application a déjà été choisi pour cette connexion',
        aotp410: 'Le code a expiré - demandez-en un nouveau',
        aotp422: 'Code ou utilisateur invalide',
        aotp425: 'Veuillez patienter quelques secondes avant de demander un nouveau code',
        aotp429: 'Trop de codes demandés - veuillez recommencer',
        aotp503: 'Impossible d\'envoyer des codes pour le moment - réessayez plus tard',
    },
};

export const profileOtpCodes = {
    en: {
        potp200: 'Two-factor settings updated',
        potp403: 'Invalid password',
        potp404: 'This request has expired - please start again',
        potp409: 'Not allowed by the current two-factor policy',
        potp410: 'The code has expired - please start again',
        potp422: 'Invalid code or user',
        potp429: 'Too many attempts - please start again',
        potp503: 'Codes cannot be delivered right now - try again later',
    },
    pt: {
        potp200: 'Configurações de dois fatores atualizadas',
        potp403: 'Senha inválida',
        potp404: 'Esta solicitação expirou - comece novamente',
        potp409: 'Não permitido pela política de dois fatores atual',
        potp410: 'O código expirou - comece novamente',
        potp422: 'Código ou usuário inválido',
        potp429: 'Muitas tentativas - comece novamente',
        potp503: 'Não é possível enviar códigos agora - tente mais tarde',
    },
    es: {
        potp200: 'Configuración de dos factores actualizada',
        potp403: 'Contraseña no válida',
        potp404: 'Esta solicitud ha caducado - vuelva a empezar',
        potp409: 'No permitido por la política de dos factores actual',
        potp410: 'El código ha caducado - vuelva a empezar',
        potp422: 'Código o usuario no válido',
        potp429: 'Demasiados intentos - vuelva a empezar',
        potp503: 'No se pueden enviar códigos en este momento - inténtelo más tarde',
    },
    fr: {
        potp200: 'Paramètres à deux facteurs mis à jour',
        potp403: 'Mot de passe invalide',
        potp404: 'Cette demande a expiré - veuillez recommencer',
        potp409: 'Non autorisé par la politique à deux facteurs actuelle',
        potp410: 'Le code a expiré - veuillez recommencer',
        potp422: 'Code ou utilisateur invalide',
        potp429: 'Trop de tentatives - veuillez recommencer',
        potp503: 'Impossible d\'envoyer des codes pour le moment - réessayez plus tard',
    },
};
